export default __webpack_public_path__ + "static/media/ic-avatar.75da7341.svg";